import React, { useState,useEffect } from "react";
import fallbackImage from 'assets/images/user/user-3-256.png'
export default function ThaiIDCard({ data, formatDate = (value) => value }) {
  const [photoFile,setPhotoFile] = useState(null)


  
  const {
    cid,
    th,
    en,
    birth_date,
    gender_ind,
    religion_ind,
    address,
    issue_date,
    expire_date,
    photo,
  } = data;

  useEffect(async()=>{
    console.log('photo',photo)
  },[photo])

  const dataURLtoFile = (dataurl) => {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], 'profile.jpg', { type: mime })
  }

  const getPhotoFile = async (path) => {
    if (!path) return setPhotoFile(null)
    const file = await dataURLtoFile(path)
    const newFile = Object.assign(file, {
      preview: path,
    })
    setPhotoFile(newFile)
  }

  if (!data) return <p>ไม่มีข้อมูลบัตร</p>;
  return (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: "12px",
        padding: "16px",
        background: "rgb(166 222 240)",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        display: "flex",
        gap: "16px",
        alignItems: "flex-start",
      }}
    >      
      <img
        src={photo || fallbackImage}
        alt="รูปบัตรประชาชน"
        style={{
          width: "120px",
          height: "160px",
          objectFit: "cover",
          borderRadius: "8px",
          border: "1px solid #aaa",
        }}
        onError={(e) => {
          e.target.onerror = null // prevent infinite loop if fallback also fails
          e.target.src = fallbackImage // your fallback image path
        }}
      />
      <div style={{ flex: 1 }}>
        <h4>{`${th?.prefix_name} ${th?.first_name} ${th?.last_name}`}</h4>
        <h6>{`${en?.prefix_name} ${en?.first_name} ${en?.last_name}`}</h6>
        <div><strong>เลขบัตร :</strong> {cid}</div>
        <div><span><strong>วันเกิด :</strong> {formatDate(birth_date)}</span><strong className='ml-1'>เพศ :</strong> {th?.gender} <strong className='ml-1'>ศาสนา :</strong> {th?.religion}</div>
        <div className='mt-1'><strong>ที่อยู่ :</strong> {address}</div>
        <div><strong>ออกบัตร :</strong> {formatDate(issue_date)} <span><strong>หมดอายุ :</strong> {formatDate(expire_date)}</span></div>
        
      </div>
    </div>
  );
}
